  <template>
  <main>
   <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
   <section class="section--user-status" id="scrollToOnLoad">
     <b-container class="container--wide">
      <div class="account" v-if="user">
        <b-row class="align-items-center">
          <b-col cols="8" sm="4" lg="5" offset="2" offset-sm="0" class="text-center">
            <img v-if="user.avatar"
              class="img-fluid account__photo" :src="domain + user.avatar" alt="">
          </b-col>
          <b-col sm="8" lg="7" class="account__position">
            <h1 class="text--black">{{ $t("hello") }}, {{user.first_name}} </h1>
            <span class="account__name text-capitalize"> {{userType}} </span>
            <div class="d-flex flex-column flex-sm-row align-items-center">
            <router-link :to="{ name: 'account_details' }" tag="button"
              v-scroll-to="'#scrollToOnLoad'"
              class="btn btn-primary btn-lg">
                {{ $t("nav.myAccount") }}
            </router-link>
            <router-link :to="{ name: 'contact_us' }" tag="button" v-scroll-to="'#scrollToOnLoad'"
              class="btn btn-primary btn-lg ml-xl-2 ml-md-3">
                {{ $t("nav.contactUs") }}
            </router-link>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
   </section>
   <section-figures :figures="figures" isStatic="true" itemColSize="4"></section-figures>
   <section-support></section-support>
  </main>
</template>

<script>
import student from '@/api/v1/student';
import teacher from '@/api/v1/teacher';
import auth from '@/api/v1/auth';
import Hero from '@/components/Hero';
import Support from '@/components/Support/Index';
import Figures from '@/components/Figures';

export default {
  data() {
    return {
      isExtended: false,
      bgImg: 'Banner5-My_Account-',
      subtitle: this.$t('nav.myAccount'),
      modalShow: false,
      userType: auth.user.user_type,
      domain: process.env.SERVER_URL,
      user: {
        avatar: '',
      },
      figures: [
        {
          imgName: 'Results.jpg',
          title: this.$t('nav.prevContent'),
          description: this.$t('nav.previouseResults'),
          btnText: this.$t('check'),
          routeName: 'prev_results',
        },
        {
          imgName: 'Pipette-tipspuzzle.jpg',
          title: this.$t('nav.myBuildingBlocks'),
          description: this.$t('nav.buildingContent'),
          btnText: this.$t('choose'),
          routeName: 'building_blocks',
        },
        {
          imgName: 'prev-results-img.jpg',
          title: this.$t('nav.reportContent'),
          description: this.$t('nav.reportContent'),
          btnText: this.$t('show'),
          routeName: 'report_my_results',
        },
      ],
    };
  },
  components: {
    'section-hero': Hero,
    'section-support': Support,
    'section-figures': Figures,
  },
  methods: {
    getUserData() {
      const succ = (response) => {
        this.user = response;
      };
      if (this.userType === 'student') {
        student.show(succ);
      } else {
        teacher.show(succ);
      }
    },
  },
  mounted() {
    this.getUserData();
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';
@import './src/styles/helpers/_include-media.scss';

.section--user-status {
  padding: 100px 0;
  @include media('<md') {
    padding: 40px 0;
  }
}
.account {
  background-color: #E4E4E4;
  padding: 135px 97px 130px 97px;
  @include media('<lg') {
   padding: 50px 88px 50px 88px;
  }
  @include media('<md') {
    padding: 40px 30px;
  }
  &__position {
    padding-bottom: 10px;
    @include media('<lg') {
      padding-top: 10px;
    }
    @include media('<md') {
      padding: 40px 0 0 20px;
    }
  }
  &__name {
    text-transform: capitalize;
    color: $color--gray-3;
    font-size: 28px;
    line-height: 28px;
    display: block;
    padding-top: 10px;
    @include media('<lg') {
      font-size: 16px;
      padding-top: 0;
    }
  }
  &__content{
    color: $color--black;
    font-size: 16px;
    padding-top: 20px;
    display: block;
    padding-left: 90px;
    position: relative;
    line-height: 20px;
    @include media('<md') {
      padding-left: 50px;
      font-size: 14px;
    }
  }
  &__number {
    font-size: 42px;
    font-weight: 800;
    position: absolute;
    left: 0;
    top: 30px;
    @include media('<md') {
      font-size: 30px;
    }
  }
  &__confirm {
    display: block;
    color: $color--gray-3;
    font-size: 16px;
    padding: 20px 0 10px;
    @include media('<lg') {
      font-size: 12px;
      letter-spacing: -0.1px;
    }
  }
  &__photo {
    width: 250px;
    height: auto;
  }
}

.button{
  &__confirm {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/User/UserProfile.vue